import { useMutation } from "@apollo/client";
import { gql } from "__generated__/gql";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { showSnackbar } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { useStoreState } from "ezStore";

const useUserPreferences = () => {
	const { instance: { forceRefreshAccessTokenAndUserDetails, getUserDetails: userDetails } } = useCoastguard();
	const [ updateUserPreferences ] = useMutation(UPDATE_USER_PREFERENCES_MUTATION);
	const { session } = useStoreState(store => store);

	return async({ preferences, successCallback, errorCallback }: {
		preferences: Record<string, unknown>,
		successCallback?: (param: { id: number, userPreferences?: unknown, __typeName?: string } | undefined) => void,
		errorCallback?: (error: string) => void,
	}) => {

		const currentPreferences = session.user?.properties.userPreferences || {};
		await updateUserPreferences({
			variables: {
				accountUuid: userDetails?.accountUuid,
				userPreferences: {
					...currentPreferences,
					...preferences,
				},
			},
		}).then(({ data }) => {
			const updatedUserPreferences = data?.updateUserPreferences;

			forceRefreshAccessTokenAndUserDetails();

			if (successCallback) {
				successCallback(updatedUserPreferences);
			}

			showSnackbar(intl.formatMessage({ id: "SUCCESSFUL_SAVED" }), { variant: "success" });
		}).catch((error: string) => {
			if (errorCallback) {
				errorCallback(error);
			}

			showSnackbar(error, { variant: "error" });
		});
	};
};

export default useUserPreferences;

const UPDATE_USER_PREFERENCES_MUTATION = gql(`#graphql
    mutation updateUserPreferences($accountUuid: Uuid!, $userPreferences: Json!) {
        updateUserPreferences(accountUuid: $accountUuid, userPreferences: $userPreferences) {
            id
			userPreferences
        }
    }
`);
